import React from 'react';
import PixelIcons from '../components/PixelIcons.jsx';
import { useT } from '../i18n/useT.js';

// Clients.jsx — Wall of clients marquee
const Clients = (() => {
  const clientList = [
    { src: "/assets/clients/ymca-cali.webp", name: "YMCA Cali" },
    { src: "/assets/clients/club-dragones.webp", name: "Club Dragones" },
    { src: "/assets/clients/faceit.webp", name: "FaceIT" },
    { src: "/assets/clients/handtronik.webp", name: "Handtronik" },
    { src: "/assets/clients/pacific-travel.webp", name: "Pacific Travel" },
    { src: "/assets/clients/effective-language.webp", name: "Effective Language" },
    { src: "/assets/clients/partners-colombia.webp", name: "Partners Colombia" },
    { src: "/assets/clients/districya.webp", name: "Districya" },
    { src: "/assets/clients/eeymuc.webp", name: "EEYMUC" },
    { src: "/assets/clients/daater.webp", name: "Daater" },
  ];

  const clStyles = {
    section: {
      padding: "72px 0",
      background: "var(--ragross-purple-night)",
      borderTop: "1px solid var(--border-soft)",
      borderBottom: "1px solid var(--border-soft)",
    },
    container: { maxWidth: 1280, margin: "0 auto", padding: "0 32px" },
    head: { display: "flex", justifyContent: "space-between", alignItems: "baseline", flexWrap: "wrap", gap: 16, marginBottom: 28 },
    tag: {
      fontFamily: "'Press Start 2P', monospace",
      fontSize: "10px", letterSpacing: "0.16em",
      color: "var(--ragross-cyan)",
    },
    title: { font: "var(--type-h2)", color: "#fff", marginTop: 8, marginBottom: 0 },
    sub: { font: "var(--type-caption)", color: "var(--fg-3)", letterSpacing: "0.10em" },
    wallWrap: {
      overflow: "hidden",
      position: "relative",
      borderTop: "1px solid var(--border-soft)",
      borderBottom: "1px solid var(--border-soft)",
      padding: "18px 0",
    },
    track: {
      display: "flex",
      gap: 48,
      animation: "clientMarquee 50s linear infinite",
      width: "max-content",
    },
    tile: {
      height: 56,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      opacity: 0.55,
      transition: "opacity 200ms, filter 200ms",
      filter: "grayscale(1) brightness(1.5)",
    },
    tileHover: { opacity: 1, filter: "grayscale(0) brightness(1)" },
    img: { maxHeight: 48, maxWidth: 140, objectFit: "contain" },
    fadeL: {
      position: "absolute", left: 0, top: 0, bottom: 0, width: 80,
      background: "linear-gradient(90deg, var(--ragross-purple-night), transparent)",
      pointerEvents: "none", zIndex: 2,
    },
    fadeR: {
      position: "absolute", right: 0, top: 0, bottom: 0, width: 80,
      background: "linear-gradient(-90deg, var(--ragross-purple-night), transparent)",
      pointerEvents: "none", zIndex: 2,
    },
  };

  function ClientTile({ c }) {
    const [hover, setHover] = React.useState(false);
    return (
      <div
        style={{ ...clStyles.tile, ...(hover ? clStyles.tileHover : {}) }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        title={c.name}
      >
        <img src={c.src} alt={c.name} style={clStyles.img}/>
      </div>
    );
  }

  function Clients() {
    const t = useT();
    const looped = [...clientList, ...clientList];
    return (
      <section style={clStyles.section} data-screen-label="04b Clientes">
        <div style={clStyles.container}>
          <div style={clStyles.head}>
            <div>
              <div style={clStyles.tag}>{t("cl.tag")}</div>
              <h3 style={clStyles.title}>{t("cl.title")}</h3>
            </div>
            <span style={clStyles.sub}>{t("cl.sub")}</span>
          </div>
        </div>

        <div style={clStyles.wallWrap}>
          <div style={clStyles.fadeL}></div>
          <div style={clStyles.fadeR}></div>
          <div style={clStyles.track}>
            {looped.map((c, i) => <ClientTile key={i} c={c}/>)}
          </div>
        </div>
      </section>
    );
  }

  return Clients;
})();

export default Clients;
